// 관리자 콘솔 루트 라우터 셸.
// /login 은 보호 외부, 나머지는 AdminProtectedRoute + AdminShell 안쪽에 둔다.
// 비밀번호 변경 화면(/change-password) 도 보호 라우트 안에 두며, AdminProtectedRoute 가 must_change_password 가드를 처리한다.

import { Routes, Route } from "react-router-dom";
import AdminShell from "./shared/AdminShell.tsx";
import AdminProtectedRoute from "./features/auth/AdminProtectedRoute.tsx";
import AdminLoginPage from "./pages/auth/AdminLoginPage.tsx";
import ChangePasswordPage from "./pages/auth/ChangePasswordPage.tsx";
import DashboardPage from "./pages/DashboardPage.tsx";
import CategoriesPage from "./pages/catalog/CategoriesPage.tsx";
import ProductsPage from "./pages/catalog/ProductsPage.tsx";
import ProductFormPage from "./pages/catalog/ProductFormPage.tsx";
import UnitsPage from "./pages/catalog/UnitsPage.tsx";
import BannersPage from "./pages/catalog/BannersPage.tsx";
import BannerFormPage from "./pages/catalog/BannerFormPage.tsx";
import MerchandisingPage from "./pages/catalog/MerchandisingPage.tsx";
import StoreSettingsPage from "./pages/operations/StoreSettingsPage.tsx";
import OrdersPage from "./pages/orders/OrdersPage.tsx";
import SalesPage from "./pages/sales/SalesPage.tsx";
import NotificationsPage from "./pages/notifications/NotificationsPage.tsx";
import MembersPage from "./pages/members/MembersPage.tsx";

// 관리자 콘솔 루트 컴포넌트.
// 라우트 레이아웃과 로그인 게이트 진입점을 한 곳에서 관리한다.
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<AdminLoginPage />} />
      <Route
        element={
          <AdminProtectedRoute>
            <AdminShell />
          </AdminProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/change-password" element={<ChangePasswordPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/sales" element={<SalesPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/members" element={<MembersPage />} />
        <Route path="/catalog/categories" element={<CategoriesPage />} />
        <Route path="/catalog/products" element={<ProductsPage />} />
        <Route path="/catalog/units" element={<UnitsPage />} />
        <Route path="/catalog/merchandising" element={<MerchandisingPage />} />
        <Route path="/catalog/products/:id" element={<ProductFormPage />} />
        <Route path="/catalog/banners" element={<BannersPage />} />
        <Route path="/catalog/banners/:id" element={<BannerFormPage />} />
        <Route path="/operations/store-settings" element={<StoreSettingsPage />} />
      </Route>
    </Routes>
  );
}
